import { showApiError, useMutation } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'
import type { UpsertLoadDTO } from '@fv/models'
import type { ClientDTO } from '@fv/models/core'

import { shipperFetch } from '@/utils/shipperFetch'

const postShipment = async (model: ClientDTO<UpsertLoadDTO>) => {
  return await shipperFetch<FullShipment[]>('/shipments', {
    method: 'POST',
    body: model,
  })
}
export const useCreateShipment = () => {
  return useMutation(postShipment, {
    onError: e => showApiError('Failed to create shipment', e),
  })
}

const putShipment =
  (loadId: string) => async (model: ClientDTO<UpsertLoadDTO>) => {
    return await shipperFetch<FullShipment>(`/shipments/${loadId}`, {
      method: 'PUT',
      body: model,
    })
  }
export const useUpdateShipment = (loadId: string) => {
  return useMutation(putShipment(loadId))
}
